import { Box } from '@mui/material';
import * as T from '../../components/Typography';
import * as S from './style';

import Modal from '../../components/Modal';
import headphoneIcon from '../assets/headphones-mic.svg';
import { routes } from '../../constants';
import colors from '../../theme/colors';
import { CloseRounded } from '@mui/icons-material';
import { supportEmail } from '../../constants/external';

const SupportModal = ({ visible, setIsModalVisible }) => {
  return (
    <Modal
      visible={visible}
      setIsModalVisible={setIsModalVisible}
      bgColor="white"
    >
      <Box
        textAlign={'right'}
        display={'flex'}
        justifyContent={'flex-end'}
        width={'100%'}
        pt={1}
        pr={1}
      >
        <CloseRounded
          sx={{ width: 24, height: 24, cursor: 'pointer' }}
          htmlColor={colors.neutral.shades.shade700}
          onClick={setIsModalVisible}
        />
      </Box>
      <Box textAlign={'left'} width={'100%'} p={4} pt={0}>
        <Box mb={4}>
          <Box mb={3}>
            <img src={headphoneIcon} />
          </Box>
          <T.H18px mb={4}>Contact support</T.H18px>
        </Box>
        <S.ContentContainer p={4}>
          <T.TextSmallBold>To get in touch, please email{' '}
            <T.Link
              to={`mailto:${supportEmail}`}
              color={colors.blue.shades.shade700}
              weight={'bold'}
            >
              {supportEmail}
            </T.Link>{' '}
          </T.TextSmallBold>
          <T.TextSmallRegular mb={4} mt={4}>
            We'll aim to reply to your query within 2 working days.
          </T.TextSmallRegular>
          <S.DashedDivider></S.DashedDivider>
          <T.TextSmallRegular>
            In the meantime, you can also check our{' '}
            <T.Link
              to={routes.FAQ}
              color={colors.blue.shades.shade700}
              weight={'bold'}
              target="_blank"
            >
              FAQs
            </T.Link>{' '}
          </T.TextSmallRegular>
        </S.ContentContainer>
      </Box>
    </Modal>
  );
};

export default SupportModal;
